import React, { useCallback, useRef } from 'react'
import { makeStyles, ButtonBase } from '@material-ui/core'
import { Add, Remove } from '@material-ui/icons'
import { gray } from '../../../utils/colors'
import { FONT_WEIGHTS } from '../../../utils'

const useStyles = makeStyles(() => ({
	root: {
		display: 'flex',
		height: '2.375rem',
		justifyContent: 'center',
		alignItems: 'center',
		border: `1px solid ${gray[500]}`,
		borderRadius: '1.1875rem',
		gap: '.7rem',
		'& .MuiSvgIcon-root': { fill: gray[700] }
	},
	button: {
		width: '2.375rem',
		height: '2.375rem',
		color: gray[700],
		'&:disabled': {
			color: gray[500]
		}
	},
	counter: {
		fontFamily: 'Nunito',
		fontSize: '0.875rem',
		fontStyle: 'normal',
		fontWeight: FONT_WEIGHTS.ExtraBold,
		lineHeight: 'normal',
		letterSpacing: '0.07813rem',
		textTransform: 'uppercase',
		color: gray[800],
		width: '1.5rem',
		textAlign: 'center'
	}
}))

const AddSubtractItemCount = ({ count = 0, onAdd, onSubtract, disabled = false }) => {
	const classes = useStyles()
	const currentCountRef = useRef(count)

	const handleAdd = useCallback(() => {
		currentCountRef.current = parseInt(currentCountRef.current, 10) + 1
		if (onAdd) {
			onAdd(currentCountRef.current)
		}
	}, [currentCountRef, onAdd])

	const handleSubtract = useCallback(() => {
		currentCountRef.current = parseInt(currentCountRef.current, 10) - 1
		if (onSubtract) {
			onSubtract(currentCountRef.current)
		}
	}, [currentCountRef, onSubtract])

	return (
		<div className={classes.root}>
			<ButtonBase
				disabled={currentCountRef.current === 0 || disabled}
				disableRipple
				onClick={handleSubtract}
				className={classes.button}>
				<Remove fontSize="small" />
			</ButtonBase>
			<div className={classes.counter}>{currentCountRef.current}</div>
			<ButtonBase disabled={disabled} disableRipple onClick={handleAdd} className={classes.button}>
				<Add fontSize="small" />
			</ButtonBase>
		</div>
	)
}

export default AddSubtractItemCount
